import { createFileRoute } from '@tanstack/react-router'
import { ChangelogPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/changelog/')({
  loader: () => loadPageData({ data: { kind: 'changelog', locale: 'en' } }),
  head: () => staticRouteHead('changelog', 'en'),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <ChangelogPage />
    </CatalogProvider>
  )
}
